(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kitvora-paid-personalization"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kitvora-priced-options'))customElements.define('kitvora-priced-options',class extends HTMLElement{
  connectedCallback(){
    if(this.initialized)return;this.initialized=true;
    this.form=document.getElementById(this.dataset.form);
    if(!this.form){this.initialized=false;this.attempts=(this.attempts||0)+1;if(this.attempts<10)requestAnimationFrame(()=>{if(this.isConnected)this.connectedCallback();});return;}
    this.variant=JSON.parse(this.querySelector('[data-selected]').textContent);this.scope=this.closest('product-info')||this.parentElement;
    this.change=()=>this.update();this.scope.addEventListener('change',this.change);
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{if(event.data.sectionId===this.dataset.section){this.variant=event.data.variant;this.update();}});
    this.submit=event=>{this.update();for(const input of this.querySelectorAll('input,select'))if(!input.reportValidity()){event.preventDefault();event.stopImmediatePropagation();return;}};
    this.form.addEventListener('submit',this.submit,true);this.update();
  }
  disconnectedCallback(){this.form?.removeEventListener('submit',this.submit,true);this.scope?.removeEventListener('change',this.change);this.unsubscribe?.();}
  update(){
    const variant=this.variant;if(!variant)return;
    const mode=variant.options[Number(this.dataset.optionIndex)]||'';
    const named=mode.includes('Nombre'),patches=mode.includes('2 parches')?2:mode.includes('parche')?1:0;
    for(const [selector,show] of [['[data-name-fields]',named],['[data-patch-field]',patches>0],['[data-extra-field]',patches>1]])this.querySelector(selector).hidden=!show;
    for(const [selector,enabled] of [['[data-name]',named],['[data-number]',named],['[data-patch]',patches>0],['[data-extra]',patches>1]]){const field=this.querySelector(selector);field.disabled=!enabled;field.required=enabled;}
    const money=value=>new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(value/100);
    this.querySelector('[data-total]').textContent=money(variant.price);
  }
});
  } catch(e) { console.error(e); }
})();

})();
